import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  addNextAvailableVariantToList,
  addNextAvailableVariantToListFailure,
  addNextAvailableVariantToListSuccess,
  deleteProductFromOpenedList,
  ProductListActionsBaseComponentStore,
  selectActiveList,
} from '@epicuro-next/state/product-list-state';
import { selectReplenishments } from '@epicuro-next/state/replenishment-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, switchMap } from 'rxjs';
import { filter, take, tap, withLatestFrom } from 'rxjs/operators';
@Injectable()
export class ProductCardActionsComponentStore extends ProductListActionsBaseComponentStore {
  public readonly replenishments$ = this.store.select(selectReplenishments);

  public readonly addNextAvailableVariant = this.effect(
    (void$: Observable<void>) =>
      void$.pipe(
        tap(() => this.patchState({ isBookmarking: true })),
        withLatestFrom(
          this.store.select(selectActiveList),
          this.product$.pipe(filter(isNonNullish)),
        ),
        tap(([_, activeList, product]) => {
          this.store.dispatch(
            addNextAvailableVariantToList({
              list: activeList,
              product,
            }),
          );
        }),
        switchMap(([_, __, product]) => {
          return this.actions$
            .pipe(
              ofType(
                addNextAvailableVariantToListFailure,
                addNextAvailableVariantToListSuccess,
              ),
              filter(
                (action) =>
                  action.product?.parentId === product?.productId &&
                  action.product?.brandId === product?.brandId,
              ),
            )
            .pipe(
              tap(() => {
                this.patchState({ isBookmarking: false });
              }),
            );
        }),
      ),
  );

  constructor(
    protected readonly store: Store,
    public router: Router,
    private actions$: Actions,
  ) {
    super(store, router);
  }

  public deleteFromProductList() {
    this.product$.pipe(take(1), filter(Boolean)).subscribe((product) => {
      this.store.dispatch(
        deleteProductFromOpenedList({
          product,
        }),
      );
    });
  }
}
